import React, { useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from '@mui/icons-material/Send';

function Focus() {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const handleSend = () => {
    // Your send message logic here
    setLoading(true);
    // Simulate a send action
    setTimeout(() => {
      setLoading(false);
      setMessage('');
    }, 2000);
  };

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div>
      <TextField
        label="Type your message"
        variant="outlined"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        inputRef={inputRef} // Use inputRef prop to access the input element
        id="inputmessage"
        fullWidth
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={handleSend}
                disabled={!message.trim()}
                size="small"
              >
                {loading ? (
                  <CircularProgress color="secondary" size="20px" />
                ) : (
                  <SendIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <button onClick={handleClick}>Focus Input</button>
    </div>
  );
}



export default Focus